"use client";

import { Bike, Coffee, KeyRound, Leaf, Phone, Printer, Sun, Wifi } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function IndustriesServed() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const perks = [{
    icon: Wifi,
    title: "Automotive Sector",
    description: "Precision CNC solutions for high-volume vehicle component manufacturing.",
    span: "md:col-span-2",
    highlight: false
  }, {
    icon: Coffee,
    title: "Aerospace Engineering",
    description: "Ultra-tight tolerances for critical flight and structural components.",
    span: "md:col-span-1",
    highlight: true
  }, {
    icon: Phone,
    title: "Energy & Power",
    description: "Heavy-duty machining support for turbine and generator parts.",
    span: "md:col-span-1",
    highlight: false
  }, {
    icon: Printer,
    title: "Tool & Die Making",
    description: "Advanced Siemens integration for complex mold and die fabrication.",
    span: "md:col-span-1",
    highlight: false
  }, {
    icon: Bike,
    title: "Mining Industry",
    description: "Robust field services for heavy machinery in harsh environments.",
    span: "md:col-span-1",
    highlight: false
  }, {
    icon: Leaf,
    title: "General Engineering",
    description: "Versatile CNC support for diverse industrial manufacturing needs.",
    span: "md:col-span-1",
    highlight: false
  }, {
    icon: Sun,
    title: "Defense Systems",
    description: "Secure and reliable integration for high-spec defense hardware.",
    span: "md:col-span-2",
    highlight: false
  }];
  return <section data-section-id="401" id="industries-served" className="bg-background text-foreground py-20 md:py-28 lg:py-32">
      <div ref={ref} className={`mx-auto max-w-7xl px-6 lg:px-8 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          {}
          <div className="lg:col-span-5">
            <div className="lg:sticky lg:top-24">
              <p className="font-mono text-xs tracking-widest uppercase text-muted-foreground mb-6">SECTORS</p>
              <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-bold leading-[1.1] tracking-tighter text-foreground mb-6">
                Industries we
                <br />
                <span className="italic font-serif font-normal text-secondary-foreground">
                  empower daily.
                </span>
              </h2>
              <p className="font-default text-base md:text-lg text-muted-foreground leading-relaxed max-w-md">
                Providing specialized Siemens CNC integration and field services across South Africa&apos;s most demanding industrial landscapes.
              </p>
            </div>
          </div>

          {}
          <div className="lg:col-span-7">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
              {perks.map((perk, i) => {
              const Icon = perk.icon;
              return <div key={i} data-index={i} className={`group relative border border-border rounded-md p-6 md:p-7 transition-all duration-500 ease-out hover:-translate-y-1 hover:shadow-md ${perk.span} ${perk.highlight ? "bg-primary text-primary-foreground border-primary" : "bg-card text-card-foreground"}`}>
                    <div className={`flex items-center justify-center w-12 h-12 rounded-md mb-5 transition-transform duration-700 ease-out group-hover:rotate-[360deg] ${perk.highlight ? "bg-foreground text-background" : "bg-secondary text-foreground"}`}>
                      <Icon className="w-5 h-5 text-secondary-foreground" strokeWidth={1.5} />
                    </div>
                    <h3 className={`font-default text-lg md:text-xl font-bold mb-2 tracking-tight ${perk.highlight ? "text-primary-foreground" : "text-foreground"}`}>
                      {perk.title}
                    </h3>
                    <p className={`font-default text-sm leading-relaxed ${perk.highlight ? "text-primary-foreground/80" : "text-muted-foreground"}`}>
                      {perk.description}
                    </p>
                  </div>;
            })}
            </div>
          </div>
        </div>
      </div>
    </section>;
}